// components
import maInputSelect from '@/components/input/modules/select'

// api
import {
  apiGetAdminDamagesWarrantyTypes,
  apiGetAdminDamagesWarrantySubtypes
} from '@/services/API/admin'

export default {
  name: 'Filters',
  data: function () {
    return {
      filter: {
        warranty: null,
        subwarranty: null
      },
      warrantyTypes: [],
      subwarrantyTypes: []
    }
  },
  components: {
    maInputSelect
  },
  methods: {
    setWarrantyTypesFilter: function () {
      apiGetAdminDamagesWarrantyTypes()
        .then(types => {
          if (types && types.length > 0) {
            this.warrantyTypes = types
          }
        })
    },
    setWarrantySubtypesFilter: function () {
      const that = this
      apiGetAdminDamagesWarrantySubtypes(this.filter.warranty)
        .then(subtypes => {
          if (subtypes && subtypes.length > 0) {
            that.subwarrantyTypes = subtypes
          }
        })
    },
    handleFilterChange: function (event) {
      if (event) {
        this.filter.subwarranty = null
        this.filter.warranty = event

        this.$emit('filter:change', this.filter)
        this.setWarrantySubtypesFilter()
      } else {
        this.filter.subwarranty = null
        this.filter.warranty = null

        this.$emit('filter:change', this.filter)
      }
    },
    handleSubfilterChange: function (event) {
      if (event) {
        this.filter.subwarranty = event
        this.$emit('filter:change', this.filter)
      } else {
        this.filter.subwarranty = null
        this.$emit('filter:change', this.filter)
      }
    }
  },
  beforeMount: function () {
    this.setWarrantyTypesFilter()
  }
}
